import { Button, Form, Input, InputNumber } from "antd";
import { FormattedMessage } from "react-intl";
import DatePickerField from "components/fields/DatePickerField";
import EventSelect from "components/data/EventSelect";
import CheckboxGroupField from "components/fields/CheckboxGroupField";

import { DiscountCodeFormValue, DiscountCodeFormProps } from "./types";
import {
  discountCodeEventsFieldLayout,
  discountCodeFormLayout,
} from "./consts";
import { useDiscountCodeForm } from "./hooks";

const DiscountCodeForm: React.FC<DiscountCodeFormProps> = ({
  loading,
  form,
  items,
  ...props
}) => {
  const { eventOptions, eventSelect } = useDiscountCodeForm(form);

  return (
    <Form<DiscountCodeFormValue>
      {...discountCodeFormLayout}
      {...props}
      {...{ form }}
    >
      <Form.Item
        label={<FormattedMessage defaultMessage="Discount Code" />}
        name={["input", "code"]}
        rules={[{ required: true }]}
        {...items?.code}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label={<FormattedMessage defaultMessage="Discount Name" />}
        name={["input", "name"]}
        rules={[{ required: true }]}
        {...items?.name}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label={<FormattedMessage defaultMessage="Discount Amount" />}
        name={["input", "amount"]}
        rules={[{ required: true }]}
        {...items?.amount}
      >
        <InputNumber precision={2} />
      </Form.Item>
      <Form.Item
        label={<FormattedMessage defaultMessage="Apply To" />}
        {...items?.events}
      >
        <EventSelect {...eventSelect} />
      </Form.Item>
      <Form.Item
        name={["input", "events"]}
        {...discountCodeEventsFieldLayout}
        hidden={!eventOptions.length}
        {...items?.events}
      >
        <CheckboxGroupField
          options={eventOptions}
          valueProp="id"
          labelProp="name"
        />
      </Form.Item>
      <Form.Item
        name={["input", "isApplicableToAllEvents"]}
        hidden
        {...items?.isApplicableToAllEvents}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label={<FormattedMessage defaultMessage="Number of Uses" />}
        extra={<FormattedMessage defaultMessage="0 - no limit" />}
        name={["input", "maxUse"]}
        rules={[{ required: true }]}
        {...items?.maxUse}
      >
        <InputNumber precision={0} />
      </Form.Item>
      <Form.Item
        label={<FormattedMessage defaultMessage="Expires On" />}
        name={["input", "expireAt"]}
        rules={[{ required: true }]}
        {...items?.expireAt}
      >
        <DatePickerField utc showTime />
      </Form.Item>
      <Form.Item
        label={
          <FormattedMessage defaultMessage="Number of Tickets Applied in Order" />
        }
        name={["input", "numberOfTicketsAppliedInOrder"]}
        rules={[{ required: true }]}
        {...items?.numberOfTicketsAppliedInOrder}
      >
        <InputNumber precision={0} />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" {...{ loading }}>
          <FormattedMessage defaultMessage="Submit" />
        </Button>
      </Form.Item>
    </Form>
  );
};

export default DiscountCodeForm;
